import {
  POST_REGISTER_REQUEST,
  POST_REGISTER_SUCCESS,
  POST_REGISTER_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case POST_REGISTER_REQUEST:
      return { ...state, isLoading: true, error: null };
    case POST_REGISTER_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case POST_REGISTER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
